import { useSelector } from "react-redux";
import FetcherSettings from "../../../components/DataCollection/FetcherSettings/FetcherSettings";
import ComingSoon from "../../../components/ComingSoon/ComingSoon";
import Page404 from "../../../components/Page404/Page403";
import { CheckPermissions } from "../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import { selectUserData } from "../../../features/userSlice";
import {
  FETCHER_CAPABILITY,
  FETCHER_VIEW_PERMISSION,
} from "../../../components/DataCollection/FetcherSettings/helpers/fetcherPermissions";

const FetcherSettingsScreen = () => {
  const userData = useSelector(selectUserData);
  const hasFetcherSettingsPermission = CheckPermissions(
    userData?.data?.products?.data_collection,
    FETCHER_CAPABILITY,
    FETCHER_VIEW_PERMISSION,
  );

  if (import.meta.env.VITE_ENV === "production") return <ComingSoon />; // env-check: intentional

  return hasFetcherSettingsPermission ? <FetcherSettings /> : <Page404 />;
};

export default FetcherSettingsScreen;
